import React, { useContext, useEffect, useState } from 'react'

import { confirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from 'primereact/checkbox';

import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid';
import { AuthContext } from '../../../../../Base/Context/AuthContext/AuthContext';
import { toastShow } from '../../../../../Base/Services/ToastService';
import { getAgentesCompras } from '../../../../../Base/API/IT/Accesos/AccesosRequests';

import { ChangeAuth, ChangeAuth1, getAutorizaciones } from '../../../../../API/Compras/Autorizaciones/AutorizacionesRequest';



const Purchases = ({setOrderToShow, setOrdenDialog, detalles, toast, setDetalles, setRequisaEdit, setShowDialog, selectedDetalle, setSelectedDetalle, actualizarRequisasScreen, getInfo }) => {
  const { userAuth } = useContext(AuthContext);
  const [hiddenPriceColumn, setHiddenPriceColumn] = useState(userAuth.AccessWeb?.split(',').map(e=> parseInt(e)).includes(29));

  const [agentesCompras, setAgentesCompras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Autorizaciones, setAutorizaciones] = useState([]);
  const [idsPermisos, setIdsPermisos] = useState([]);
  const [selected, setSelected] = useState([]);

  const [hiddenFinanzas, setHiddenFinanzas] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(30)
  );

  const [hiddenliberarRequisa, setHiddenLiberarRequisa] = useState(
    userAuth.AccessWeb.split(",")
        .map((e) => parseInt(e))
        .includes(27)
  );

  const [hiddenliberarBodega, setHiddenLiberarBodega] = useState(
    userAuth.AccessWeb.split(",")
        .map((e) => parseInt(e))
        .includes(33)
  );

  const [hiddenPlantManager, setHiddenPlantManager] = useState(
    userAuth.AccessWeb.split(",")
        .map((e) => parseInt(e))
        .includes(32)
  );

    
  const obtenerAgentesCompras = async () => {
    const tempo = await getAgentesCompras();
    let lista = [];
    let Agents = [];
    tempo.forEach((e) => {
        Agents.push(e)
        lista.push(e.UserNameAgente);
    });
    setAgentesCompras(Agents)
      
    const autorizacionesData = await getAutorizaciones();
    let AutorizacionesFiltradas = autorizacionesData.filter((autorizacion) => autorizacion.IdTipo === 8 || autorizacion.IdTipo === 7 || autorizacion.IdTipo === 9)
    let Ids = AutorizacionesFiltradas.map((item) => item.IdPermisoGeneral);
    setIdsPermisos(Ids)
    setAutorizaciones(AutorizacionesFiltradas);
  }


  // CAMBIAR FIRMAS DE REVISION BODEGA Y 
  const handleCheckboxChange1 = async (event, data, IdPermisoGeneral, NombrePermiso) => {
      const dataToSend = data.map((item) => {
          return {
                  IdPurcharesRequestDetail: item?.IdPurcharesRequestDetail,
                  IdPermisoGeneral: IdPermisoGeneral,
                  Autorizo: !item[NombrePermiso],
                  IdUsuarioAutorizo: userAuth?.IdUser
              }
      });
      confirmDialog({
          message: `¿Está seguro que desea liberar ${data.length} ${data.length > 1 ? 'permisos' : 'permiso'}?`,
          header: 'Confirmación',
          icon: 'pi pi-exclamation-triangle',
          accept: async() => {
              const respuestaDetalles = await ChangeAuth1(dataToSend);
              if (respuestaDetalles[0]?.ESTADO === 1) {
                  toastShow(
                      toast,
                      "success",
                      "Guardado",
                      respuestaDetalles[0].MENSAGE
                  );
                  actualizarRequisasScreen()
              } else {
                  toastShow(
                      toast,
                      "error",
                      "Error",
                      respuestaDetalles[0].MENSAGE
                  );
              }
          },
          reject: () => {}
      });
      setSelected([]);
  };


  // CAMBIAR FIRMAS DE FINANZAS Y GERENTE PLANTA 
  const handleCheckboxChange = async (event, data, IdPermisoGeneral, NombrePermiso) => {
    const dataToSend = data.map((item) => {
        return {
                IdPurcharesRequestDetail: item?.IdPurcharesRequestDetail,
                IdPermisoGeneral: IdPermisoGeneral,
                Autorizo: !item[NombrePermiso],
                IdUsuarioAutorizo: userAuth?.IdUser
            }
    });
    confirmDialog({
        message: `¿Está seguro que desea liberar ${data.length} ${data.length > 1 ? 'permisos' : 'permiso'}?`,
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        accept: async() => {
            const respuestaDetalles = await ChangeAuth(dataToSend);
            if (respuestaDetalles[0]?.ESTADO === 1) {
                toastShow(
                    toast,
                    "success",
                    "Guardado",
                    respuestaDetalles[0].MENSAGE
                );
                getInfo()
            } else {
                toastShow(
                    toast,
                    "error",
                    "Error",
                    respuestaDetalles[0].MENSAGE
                );
            }
        },
        reject: () => {}
    });
    setSelected([]);
  };


  const enviarCorreoAsignarRequisa = async () => {
      //TODO
      // const promesa = await fetch(`${instancias.API_URL}/email/asignarRequisa/${purchase.IdPurchaseRequest}`, {
      //     method: "GET",
      //     headers: {
      //         "Content-Type": "application/json",
      //         'x-access-token': localStorage.getItem('ppfToken')
      //     }
      // })
      // promesa.json()
      //     .then(result => {
      //         toastShow(toast, 'success', 'Asignado', `Se ha enviado el correo.`);
      //     })
      //     .catch(error => {
      //         toastShow(toast, 'error', 'No enviado', `Error al enviar el correo.`);
      //     });
  }

  const columns = [
    {
      // ID
      field: "IdPurcharesRequestDetail",
      header: "ID",
      headerEn: "ID",
      className: "Xsmall",
      frozen: "frozen",
      hidden: userAuth.IdRol === 1,
    },

    {
      // ESTADO
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
    },
    {
      // NUMERO ORDEN
      field: "PurchaseRequest",
      header: "No. Requisa",
      headerEn: "No. Requisition",
      className: "small",
      body: (e) => e.PurchaseRequest,
      frozen: "frozen",
      alignFrozen: "left",
      Sumary: "count",
      align: "center",
      onCellDoubleClicked: ({ data }) => {
        Requisa(data.PurchaseRequest);
      },
      Format: "Modal",
    },
    {
      // RequestType
      field: "Type",
      header: "Tipo Requisas",
      headerEn: "Request Type",
      className: "small",
      body: (e) => e.Type,
      align: "center",
    },
    {
      // Priority
      field: "Priority",
      header: "Prioridad",
      headerEn: "Priority",
      className: "small",
      body: (rowData) => ({ ID: rowData.Priority, Estado: rowData.Priority }),
      align: "center",
      Format: "Estado",
    },
    // {
    //   // FechaPermiso4
    //   field: "FechaPermiso4",
    //   header: "Fecha Liberada",
    //   headerEn: "Priority",
    //   // className: "large",
    //   align: "center",
    //   Format: "DateTime",
    // },
    {
      // CodigoProducto
      field: "CodigoProducto",
      header: "Código Producto",
      headerEn: "Product Code",
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      // NombreProducto
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product",
      className: "Xlarge",
      body: (e) => e.NombreProducto,
    },
    {
      // Description
      field: "Description",
      header: "Decripción",
      headerEn: "Description",
      className: "medium",
      body: (rowData) => rowData.Description,
    },
    {
      // Proveedor
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "Xlarge",
      body: (rowData) => rowData.IdVendor,
    },
    {
      // PurchaseOrder
      field: "PurchaseOrder",
      header: "Orden Compra",
      headerEn: "Purchase Order",
      className: "small",
      Format:"Modal",
      body: (rowData) => rowData.PurchaseOrder,
      onCellDoubleClicked: ({ data }) => {
        OrdenC(data.PurchaseOrder);
      },
    },
    {
      // FechaPOD
      field: "FechaCreado",
      header: "Fecha OC",
      headerEn: "Date PO",
      className: "medium",
      body: (rowData) => rowData.FechaCreado,
      Format: "DateTime",
    },
    {
      // DateCreated
      field: "DateCreated",
      header: "Fecha Creada",
      headerEn: "Date Create",
      className: "small",
      body: (rowData) => rowData.DateCreated,
      // frozen: "frozen",
      Format: "DateTime",
    },
    {
      // AgentName
      field: "UserNameAgente",
      header: "Asignado a",
      headerEn: "Assigned to",
      className: "small",
      body: (rowData) => rowData.UserNameAgente,
    },
    {
      //AssignDate
      field: "AssignDate",
      header: "Fecha Asignada",
      headerEn: "Assigned Date",
      className: "medium",
      Format: "DateTime",
    },
    // {
    //   // Quantity
    //   field: "Inventario",
    //   header: "Inventario",
    //   headerEn: "Inventory",
    //   className: "Xsmall",
    //   body: (rowData) => rowData.Inventario,
    //   Format: "Decimal",
    //   Sumary: "sum",
    // },
    {
      // CurrencySymbol
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "Xsmall",
      body: (e) => e.Currency,
      Format: "CurrencySymbol",
      align: "center",
    },
    {
      //UnitSimbol
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      body: (rowData) => rowData.UnitName,
      align: "center",
    },
    {
      // Area
      field: "Area",
      header: "Área",
      className: "medium",
      body: (e) => e.IdArea,
    },
    {
      // Comment
      field: "Comment",
      header: "Comentarios",
      headerEn: "Comment",
      className: "XXlarge",
      body: (rowData) => rowData.Comment,
    },
    {
      //ASolicita
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
    },
    {
      //ASolicita
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      //TipoSuministro
      field: "NombreTipoProducto",
      header: "SubCategoría",
      headerEn: "SubCategory",
      className: "small",
    },
    {
      field: "UserNameSolicita",
      header: "Solicita",
      headerEn: "Request",
      className: "medium",
      body: (rowData) => rowData.UserName,
    },
    {
      //FechaCotizacion
      field: "FechaCotizacion",
      header: "Fecha Precio",
      headerEn: "Date Price",
      className: "large",
      body: (rowData) => rowData.FechaCotizacion,
      Format: "DateTime",
    },

    //------------------------------GERENTE PLANTA
    idsPermisos.includes(2) ? 
    {
      field: "UserNameAutorizoPlantManager",
      header: "Autorizó Planta Manager",
      className: "medium",
      body: (rowData) => rowData.Usuario,
    } : null,
    idsPermisos.includes(2) ?
    {
      field: "FechaAprobado",
      header: "Fecha Auth Planta Manager",
      className: "small",
      Format: "DateTime",
    } : null,
    //------------------------------GERENTE AREA
    idsPermisos.includes(3) ?
    {
      field: "UserNameAutorizoGerente",
      header: "Autorizó Gerente Area",
      className: "medium",
      body: (rowData) => rowData.Usuario,
    } : null,
    idsPermisos.includes(3) ?
    {

      field: "FechaLiberar",
      header: "Fecha Auth Gerente",
      className: "small",
      Format: "DateTime",
    } : null,
    //------------------------------FINANZAS
    idsPermisos.includes(1) ?
    {
      field: "UserNameAutorizoFinanzas",
      header: "Autorizó Finanzas",
      className: "medium",
    } : null,
    idsPermisos.includes(1) ?
    {
      field: "FechaFinanzas",
      header: "Fecha Auth Finanzas",
      className: "small",
      Format: "DateTime",
    } : null,

    //------------------------------BODEGA
    idsPermisos.includes(4) ?
    {
      field: "UserNameAutorizoBodega",
      header: "Autorizó Bodega",
      className: "medium",
    } : null,
    idsPermisos.includes(4) ?
    {

      field: "FechaBodega",
      header: "Fecha Auth Bodega",
      className: "small",
      Format: "DateTime",
    } : null,

    {
      // Price
      field: "Price",
      header: "Precio",
      headerEn: "Price",
      className: "Xsmall",
      body: (e) => e.Price,
      Format: "Currency",
      hidden: hiddenPriceColumn,
    },
    {
      //ISV
      // field: "ISV",
      header: "ISV 15%",
      headerEn: "TAX 15%",
      field: "TAX",
      className: "Xsmall",
      body: (rowData) => rowData.ISV,
      Format: "Currency",
      hidden: hiddenPriceColumn,
      Sumary: "sum",
    },
    {
      //ISV
      field: "ISV18",
      header: "ISV 18%",
      headerEn: "TAX 18%",
      className: "Xsmall",
      Format: "Currency",
      hidden: hiddenPriceColumn,
      Sumary: "sum",
    },
    {
      //Descuento
      field: "Discount",
      header: "Descuento",
      headerEn: "Discount",
      className: "Xsmall",
      body: (rowData) => rowData.Discount,
      Format: "Currency",
      hidden: hiddenPriceColumn,
      Sumary: "sum",
    },
    {
      //SubTotal
      field: "SubTotal",
      header: "SubTotal",
      className: "Xsmall",
      body: (rowData) => rowData.SubTotal,
      Format: "Currency",
      hidden: hiddenPriceColumn,
      Sumary: "sum",
    },
    {
      // Total
      field: "Total",
      header: "Total",
      className: "Xsmall",
      body: (rowData) => rowData.Quantity,
      Format: "Decimal",
      hidden: hiddenPriceColumn,
      Sumary: "sum",
    },
    {
      //Lempiras
      field: "TotalL",
      header: "Lempiras",
      className: "small",
      body: (rowData) => rowData.TotalL,
      Format: "Currency",
      hidden: hiddenPriceColumn,
      Sumary: "sum",
    },
    {
      //Dolares
      field: "TotalD",
      header: "Dolares",
      className: "small",
      body: (rowData) => rowData.TotalD,
      Format: "Currency",
      hidden: hiddenPriceColumn,
      Sumary: "sum",
    },
    {
      //Euros
      field: "TotalE",
      header: "Euros",
      className: "small",
      body: (rowData) => rowData.TotalE,
      Format: "Currency",
      hidden: hiddenPriceColumn,
      Sumary: "sum",
    },
    {
      // Quantity
      field: "Quantity",
      header: "Cantidad",
      headerEn: "Quantity",
      className: "Xsmall",
      body: (rowData) => rowData.Quantity,
      Format: "Decimal",
      Sumary: "sum",
      frozen: true,
      alignFrozen: "right"
    },
    ...Autorizaciones.map((autorizacion) => {
      return {
        field: autorizacion?.NombrePermiso,
        header: autorizacion.NombrePermiso,
        frozen: true,
        alignFrozen: "right",
        Format: "Template",
        align: "center",
        className: "Xsmall",
        filter: false,
        editable: false,
        body: (rowData) => {
          return (
            rowData.IdPurcharesRequestDetail ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '2px' }}>
            <Checkbox
              checked={rowData[autorizacion?.NombrePermiso] === 1}
            />
          </div> : null
          );
        }
      }
    })
  ];


  const table = {
      Columns: columns,
      Data: detalles,
      fileName: "RequisasCompras" + (new Date()).toDateString(),
      loading: loading,
      clases: "tablaListados",
      selected: selectedDetalle,
      setSelected: e => setSelectedDetalle(e),
      showModal: e => showModal(e),
      key: 'IdPurcharesRequestDetail',
  }


  const showModal = (tipoModal) => {
    if (tipoModal === 'requisa') {
      setShowDialog(true); 
    } else if (tipoModal === 'ordenCompra') {
      setOrdenDialog(true); 
    }
  };

  const Requisa = (Id) =>{
    setRequisaEdit(Id)
    setShowDialog(true);
  }

  const OrdenC = (Id) => {
    setOrderToShow(Id);
    setOrdenDialog(true);
    showModal('ordenCompra'); 
  };

  useEffect(() => {
      obtenerAgentesCompras();
  }, [])

    return (
      <div style={{ height: "82vh" }}>
        <AgGrid table={table} />
      </div>
    );
}

export default Purchases